import React from "react";
import clsx from "clsx";
import styles from "../styles/GalleryCardItem.module.scss";
import { NFTMedia } from "./NFTMedia";
import { isMinted, toNFTMediaItem } from "../utils/rcsNft";
import Spacer from "./Spacer";
import { COLLECTION } from "../utils/constants";
import Blockie from "./Blockie";
import { getEllipsisTxt } from "../utils/formatters";
import { RCSANFT } from "../utils/types";
import { getTheme } from "../utils/theme";
import { useAddToCart } from "../utils/cart";
import { useTranslation } from "react-i18next";
import Link from "next/link";

interface Props {
  item: RCSANFT;
  width: number;
  containerClassName?: string;
}

const GalleryCardItem: React.FC<Props> = ({
  item,
  width,
  containerClassName,
}) => {
  const minted = isMinted(item);
  const theme = getTheme(item.theme);
  const addToCart = useAddToCart();
  const { t } = useTranslation();

  return (
    <Link href={`/token/${item.tokenId}`}>
      <a
        className={clsx(
          "column ai-start cursor-pointer",
          styles.itemContainer,
          containerClassName
        )}
        style={{ background: theme.background }}
      >
        <NFTMedia item={toNFTMediaItem(item)} width={width} />
        <Spacer height={24} />
        <div className={styles.label} style={{ color: theme.cardBackground }}>
          {t("token.collection")}:
        </div>
        <Spacer height={4} />
        <div className={styles.value} style={{ color: theme.cardBackground }}>
          {COLLECTION}
        </div>

        {minted ? (
          <>
            <Spacer height={16} />

            <div
              className={styles.label}
              style={{ color: theme.cardBackground }}
            >
              {t("gallery.creatorRoyalties")}:
            </div>
            <Spacer height={4} />
            <div
              className={styles.value}
              style={{ color: theme.cardBackground }}
            >
              {item.royalitiesEarned > 0
                ? `${item.royalitiesEarned}ETH`
                : "---"}
            </div>

            <Spacer height={16} />

            <div
              className={styles.label}
              style={{ color: theme.cardBackground }}
            >
              {t("token.createdBy")}:
            </div>
            <Spacer height={4} />
            <div className={"row ai-center"}>
              <Blockie
                address={item.creatorAddress}
                scale={3}
                size={7.4}
                className={styles.blockie}
              />
              <Spacer width={8} />
              <div
                className={styles.value}
                style={{ color: theme.cardBackground }}
              >
                {getEllipsisTxt(item.underlyingNftContractAddress)}
              </div>
            </div>
          </>
        ) : (
          <>
            <Spacer height={73} />
            <div
              className={styles.ownItButton}
              onClick={(e) => {
                e.preventDefault();
                return addToCart({
                  tokenId: item.underlyingNftTokenId,
                  contractAddress: item.underlyingNftContractAddress,
                });
              }}
            >
              {t("gallery.ownIt")}
            </div>
          </>
        )}
      </a>
    </Link>
  );
};

export { GalleryCardItem };
